import { redsStarterItems } from '@/config/reds';
import type { Person } from '@/domain/types';
import { createStarterItems } from './items';
import { addPerson } from './people';
import { rt } from './runtime';
import { DEFAULT_SETTINGS } from './settings';
import { DomainError, inTx, nowIso } from './write';

/**
 * First start on Red's tablet: the owner, the settings, and the drink lists from Red's
 * sheets. Or, with `withLists: false`, an empty tablet waiting for the latest week's Excel
 * file to bring everything back.
 */
export async function setupReds(input: { name: string; initials?: string; pin?: string | null; withLists: boolean }): Promise<Person> {
  const db = rt().db;
  if ((await db.people.count()) > 0) throw new DomainError('This tablet is already set up.');
  await inTx(['settings'], () => db.settings.put({ ...DEFAULT_SETTINGS, updatedAt: nowIso(), version: 1 }));
  const owner = await addPerson({ name: input.name, initials: input.initials, role: 'owner', pin: input.pin ?? null });
  if (input.withLists) await createStarterItems(redsStarterItems());
  return owner;
}
